export default __webpack_public_path__ + "static/media/AAVE.0a64aa49.svg";